export default __webpack_public_path__ + "static/media/arrow.04d5a698.svg";